window.addEventListener("load", function () {
    // Khi user đã login (global var isLogin === 1/true) → add class .isLogin lên
    // .list-icons-sub để CSS shift dropdown sang trái (bù width btn-logout > btn-login).
    if (typeof isLogin !== "undefined" && (isLogin === 1 || isLogin === true)) {
        $(".list-icons-sub").addClass("isLogin");
    }

    var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");
    if (!musicUrl) return;

    var audioElement = $('<audio id="backgroundMusic" loop></audio>');
    audioElement.append('<source src="' + musicUrl + '" type="audio/mpeg">');
    $("body").append(audioElement);

    var audio = document.getElementById("backgroundMusic");
    var hasInteracted = false;
    // $(".btn-music") catch cả nav (PC) lẫn mobile menu (.btn-music corner)
    var $btnMusic = $(".btn-music");
    // .menu-nav__item--amthanh = audio toggle trong mobile menu nav (item thứ 1)
    var $btnAmThanh = $(".menu-nav__item--amthanh");

    var syncBtnState = function () {
        if (audio.paused) {
            // paused → music sprite "off" + amthanh "active" (visual mute)
            $btnMusic.removeClass("MS__sprite-musicon").addClass("MS__sprite-musicoff");
            $btnAmThanh.addClass("active");
        } else {
            $btnMusic.removeClass("MS__sprite-musicoff").addClass("MS__sprite-musicon");
            $btnAmThanh.removeClass("active");
        }
    };
    audio.addEventListener("play", syncBtnState);
    audio.addEventListener("pause", syncBtnState);
    syncBtnState();

    // Toggle audio — bind cho cả PC nav .btn-music + mobile menu .amthanh
    var toggleAudio = function (e) {
        e.preventDefault();
        hasInteracted = true;
        if (audio.paused) {
            audio.play().catch(function (error) {
                console.log("Audio play error:", error);
            });
        } else {
            audio.pause();
        }
    };

    $btnMusic.on("click", toggleAudio);
    $btnAmThanh.on("click", toggleAudio);

    var autoPlayHandler = function () {
        if (hasInteracted) return;
        hasInteracted = true;
        audio.play().catch(function (error) {
            console.log("Autoplay prevented:", error);
        });
        $(document).off("click touchstart", autoPlayHandler);
    };
    $(document).on("click touchstart", autoPlayHandler);

    document.addEventListener("visibilitychange", function () {
        if (document.hidden) {
            if (!audio.paused) audio.pause();
        } else if (hasInteracted && audio.paused) {
            audio.play().catch(function (error) {
                console.log("Audio resume error:", error);
            });
        }
    });
});
